import React from 'react'

import { IndexLayoutLoading } from '../IndexLayout'

export const WorkspaceSubscribeLoadingPage = () => {
  return <IndexLayoutLoading />
}
